import { bulkDownload } from '../api/epo';

export const handleDownloadFile = (buffer, filename) => {
  if (!buffer) return;
  const fileURL = window.URL.createObjectURL(new Blob([buffer]));
  const a = document.createElement('a');
  console.log('file url is', fileURL);
  document.body.appendChild(a);
  a.href = fileURL;
  a.download = filename;
  a.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(fileURL);
    a.remove();
  }, 0);
};

export const downloadAllEPOFiles = async (loadId, filename = 'epo-documents.zip') => {
  const data = await bulkDownload(loadId);
  handleDownloadFile(data, filename);
};
